import Vue from "vue";

import "ie9-oninput-polyfill";
// import "classlist-polyfill";

import constant from "@/constant";
import "font-awesome/css/font-awesome.min.css";
import "element-ui/lib/theme-chalk/index.css";
import "./element";
import "@/assets/css/element-variables.scss";
import "@/assets/css/index.scss";

import VueProgressBar from "vue-progressbar";

import App from "./App.vue";
import router from "./router";
import store from "./store/";
import req from "@/assets/js/req";
import util from "@/util";
import cache from "@/assets/js/cache";
import log from "@/assets/js/log";

let _conf = util.getConfig();
Vue.config.productionTip = true;

// use vue-progressbar
Vue.use(VueProgressBar, {
    color: "rgb(143, 255, 199)",
    failedColor: "red",
    height: "2px"
});
//  Number 对象的 parseInt 和 parseFloat 方法兼容IE
if (Number.parseInt === undefined) Number.parseInt = window.parseInt;
if (Number.parseFloat === undefined) Number.parseFloat = window.parseFloat;
// bind router guard to start/stop progressbar
router.beforeEach(function(to, from, next) {
    try {
        Vue.prototype.$msgbox.close();
    } catch (ex) {
        /* console.log(ex); */
    }
    // 跳转登录页面，如果路由配置中要求登录，但登录状态为false
    if (to.meta.requiresAuth && !store.state.login.status) {
        log.action({
            eventkey: "login",
            eventtitle: "登录",
            referpagecode: from.name,
            eventvalue: { msg: "跳转页面[" + to.path + "]时没有权限" }
        });
        next({ path: "/" });
        return false;
    } else if (!to.meta.requiresAuth && store.state.login.status && to.path !== "/errGeneral" && to.path !== "/errNetwork" && to.path !== "/error404") {
        log.action({
            eventkey: "home",
            eventtitle: "我的资产",
            referpagecode: from.name,
            eventvalue: {
                msg: "跳转页面[" + to.path + "]时已有登录权限，返资产页面..."
            }
        });
        next({ path: "/home" });
        return false;
    }
    // 路由自定义检查
    if (to.meta.requiresCheck) {
        if (!to.meta.requiresCheck.func(to, from, next, to.meta.requiresCheck.params)) {
            return false;
        }
    }
    log.action({
        eventkey: to.name,
        eventtitle: to.meta.nameText,
        referpagecode: from.name,
        eventvalue: {
            msg: "跳转" + to.meta.nameText + "页面[" + to.path + "]",
            fundcode: to.query.fundcode || ""
        }
    });
    Vue.prototype.$Progress.start();
    // store.dispatch("setRouterCache", {name: to.name, path: to.path, params: to.params});
    next();
});
router.afterEach(function(to, from) {
    // 加载下一个页面默认滚动到顶部
    window.scrollTo(0, 0);
    Vue.prototype.$Progress.finish();
});
Vue.prototype.$req = req;
Vue.prototype.$util = util;
Vue.prototype.$cache = cache;
Vue.prototype.$log = log;
Vue.prototype.$const = constant;
log.info("初始化缓存...");
console.log("JTUP一体化平台V4.0.0");
let initVue = () => {
    document.getElementById("cacheLoading").style.display = "none";
    new Vue({
        router,
        store,
        render: h => h(App)
    }).$mount("#app");
};
let initData = () => {
    const params = util.getUrlParams() || {};
    if (params.location === "jweb" && (router.history.current.name === null || router.history.current.name === "")) { 
        const _x = JSON.parse(localStorage.getItem("_a") || "{}");
        const _b = localStorage.getItem("_b") || "";
        if (_x.token && _b === "1") {
            sessionStorage.setItem("_a", JSON.stringify(_x));
            cache.init().then(function() {
                store.dispatch("login", _x).then(() => {
                    if (params.proto) {
                        const _y = params.proto;
                        util.fundRiskCheckWeb(store,router, params, res => {
                            if (res) {
                                const _x = Object.assign({}, res);
                                sessionStorage.setItem(_y === "buy" ? "buyfund" : "generalbuy", JSON.stringify(_x));
                                initVue();
                            }else{
                                initVue();
                            }
                        });
                        return;
                    }
                    initVue();
                });
            });
            return;
        }
    }
    cache.init().then(function() {
        if(store.state.login.status && localStorage.getItem("_b") === null){
            const _x = JSON.parse(sessionStorage.getItem("_a") || "{}");
            localStorage.setItem("_a", JSON.stringify(_x));
            // localStorage.setItem("_b", "1");
        }
        initVue();
    });
};
initData();
// 解决ie9下 elementUI NavMenu 使用new MouseEvent报错问题
(function (window) {
    try {
        new MouseEvent("test");
        return false; // No need to polyfill
    } catch (e) {
        // Need to polyfill - fall through
    }

    // Polyfills DOM4 MouseEvent
    var MouseEventPolyfill = function (eventType, params) {
        params = params || { bubbles: false, cancelable: false };
        var mouseEvent = document.createEvent("MouseEvent");
        mouseEvent.initMouseEvent(eventType,
            params.bubbles,
            params.cancelable,
            window,
            0,
            params.screenX || 0,
            params.screenY || 0,
            params.clientX || 0,
            params.clientY || 0,
            params.ctrlKey || false,
            params.altKey || false,
            params.shiftKey || false,
            params.metaKey || false,
            params.button || 0,
            params.relatedTarget || null
        );

        return mouseEvent;
    };

    MouseEventPolyfill.prototype = Event.prototype;

    window.MouseEvent = MouseEventPolyfill;
})(window);
